import { OverlayRootState } from "@/overlay/store/OverlayRootState";
import { GetterTree } from "vuex";
import { Notification, NotificationState } from "../types";

export const getters: GetterTree<NotificationState, OverlayRootState> = {
  notification(state): Notification | undefined {
    return state.notification;
  },
};
